
import img0 from './Images/ConfiguratorStart.png';
import img1 from './Images/DeviceVerify.png';
import img2 from './Images/DeviceConsent.png';
import img3 from './Images/ConfiguratorClient.png';
import img4 from './Images/ConfiguratorSuccess.png';
import img5 from './Images/RegisteredClient.png';
import img6 from './Images/ApproveClient.png';
import img7 from './Images/ConfiguratorStartLinux.png';
import img8 from './Images/DeviceVerify.png';
import img9 from './Images/DeviceConsent.png';
import img10 from './Images/ConfiguratorClientLinux.png';
import img11 from './Images/ConfiguratorSuccessLinux.png';
import img12 from './Images/RegisteredClientLinux.png';
import img13 from './Images/ApproveClientLinux.png';
import img14 from './Images/CreateClient.png';
import img15 from './Images/ClientCredentials.png';
  
const content = `# OnData Client Registration

Prior to using the OnData Encryption Tool or any of the OnData database drivers, you need to register them as a OnData Client in order to establish secure connectivity to 
the OnData Platform. The configuration can be done with the **OnData Configurator** utility that comes with the OnData Encryption Tool package and the OnData database driver 
packages. Below are the steps to perform the OnData client registration on both Windows and Linux platforms.  

Under scenarios that the client registration process cannot be performed with the OnData Configurator, such as in a cloud Platform-as-a-Service environment, OnData offers an 
approach to create a client directly at the OnData Portal, and use a shared secret between the client and the OnData Portal for authentication purpose. For details on how to 
create a client with a shared secret, please refer to Section 3 below.  

Please note that a client can either be registered with the OnData Configurator, or be created directly at the OnData Portal, but not using both approaches. When possible, 
the client registration process should be used because the access credentials are protected. If a client has to be created from the OnData Portal, please make sure appropriate 
security measures are enforced to protect the client secret.  

Once a OnData client is successfully registered with the OnData Platform, the client needs to be granted access to one or more databases or file templates, so that the client can 
access such resources. Please refer to the [**Client Resource Access**](reference_doc#securedb/database_drivers/client_resource_access) on how to grant resource access to a client.  

## 1. Client Registration on Windows
a. Run the Configurator.exe tool. There are two ways to do that:  
* Launch a Command Prompt and navigate to the folder where the OnData Encryption Tool or the OnData database driver is installed. Run the Configurator.exe from the command line
* Launch the \`OnData Configurator\` from the shortcut in the Windows Start menu
  
b. You will be prompted to visit an activation URL with a user code, as illustrated below;  

![Configurator Start](${ img0 })  

c. Copy the activation URL to an Internet browser and enter the user code, as illustrated below;  

![Device Verify](${ img1 })  

d. You are required to login to the OnData Portal. Sign in with your OnData account and select "Yes, Allow" to register the client;  

![Device Consent](${ img2 })  

e. Go back to Command Prompt and enter a name for the client;  

![Enter Client Name](${ img3 })  

f. The Configurator.exe should display that the client registration is completed successfully. Hit the \`Enter\` key to exit the Configurator. 

![Registration Success](${ img4 })  

g. After the client is registered, sign into the OnData Portal. Go to Settings and select Organization. Under the Clients tab, find the newly registered client, as illustrated below.  

![Registered Client](${ img5 })  

h. Select the "Review" icon on the right side, and click on the "Approve" button to activate the client.  

![Approve Client](${ img6 })  

Once the client is activated, you can grant this client access to one or more databases or file templates, and start to use the OnData Encryption Tool or the OnData 
database drivers.  


## 2. Client Registration on Linux
a. From a Shell window, navigate to where the Configurator module is located. The Configurator module comes with the OnData Encryption Tool package and the OnData database driver 
packages;  
b. Change the Configurator to be executable with the \`sudo chmod +x Configurator-<version>\` command and launch the Configurator module with the \`./Configurator-<version>\` command;  
c. You will be prompted to visit an activation URL with a user code, as illustrated below;  

![Configurator Start](${ img7 })  

e. Copy the activation URL to an Internet browser and enter the user code, as illustrated below;  

![Device Verify](${ img1 })  

f. You are required to login to the OnData Portal. Sign in with your OnData account and select "Yes, Allow" to register the client;  

![Device Consent](${ img2 })  

g. Go back to Command Prompt and enter a name for the client;  

![Enter Client Name](${ img10 })  

h. The Configurator.exe should display that the client registration is completed successfully. Hit the \`Enter\` key to exit the Configurator. 

![Registration Success](${ img11 })  

i. After the client is registered, sign into the OnData Portal. Go to Settings and select Organization. Under the Clients tab, find the newly registered client, as illustrated below.  

![Registered Client](${ img12 })  

j. Select the "Review" icon on the right side, and click on the "Approve" button to activate the client.  

![Approve Client](${ img13 })  

Once the client is activated, you can grant this client access to one or more databases or file templates, and start to use the OnData Encryption Tool or the OnData 
database drivers.  
  
## 3. Client Creation with Shared Secret
An OnData driver client can be directly created at the OnData Portal. Below are the steps to create such a client:  
a. Login to the OnData Portal and click on the Settings icon on the top right corner.  
b. Select "Organization" from the dropdown menu, and select the "Clients" tab on the Organization Settings page.  
c. Under the "Database Driver" tab, click on the "Add New..." button.  
d. Provide a name and an optional description for the client, then click on the "Save" button.  

![Create Client](${ img14 })  

e. A client is created with both the "Client ID" and "Client Secret" displayed. Please copy the Client Secret and save it to somewhere safe. OnData will only display it once.  

![Client Credentials](${ img15 })  

f. The Client ID and Client Secret can be used in the OnData Driver client configuration files (OnDataDriver.config). An example is provided below:  

  \`\`\`bash
  DatabaseType = POSTGRESQL
  DriverFullPath = /usr/lib/x86_64-linux-gnu/odbc/psqlodbcw.so
  ClientId = <Client ID from OnData Portal>
  ClientSecret = <Client Secret from OnData Portal>
  \`\`\`
  
g. Grant this OnData Driver client access to one or more databases, and start to use the OnData database driver.  
  
`
  
export default content;
